<template>
    <el-dialog
      title=""
      :visible.sync="$store.state.ordereventListObj.groupFalg"
      width="90%"
      :append-to-body="true"
      :close-on-click-modal="false"
      center>
        <div class="tabs-container ng-scope">
          <div class="row">
            <div class="col-sm-12">
              <div class="ibox float-e-margins">
                <div class="ibox-content">
                  <div class="row table-responsive" style="padding-bottom:60px;">
                    <draggable 
                      class="sortable-list connectList0 agile-list"
                      style="max-height: 600px;overflow: auto;margin-bottom: 15px;"
                      v-model="rows" 
                      group="people" 
                      @start="drag=true" 
                      @end="drag=false"
                      >
                       <div v-for="(task,index) in rows" class="dragObj">
                          <div style="padding: 5px">
                              <span style="display: inline-block;">Name: {{task.title}}</span>  
                          </div>
                          <div style="padding: 5px">
                              <span style="display: inline-block;">Data: {{task['startDate']}} - {{task['endDate']}}</span>  
                          </div>
                       </div>
                    </draggable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="$store.state.ordereventListObj.groupFalg = false">Cancel</el-button>
        <el-button type="primary" @click="addEvent()">Confirm</el-button>
      </span>
    </el-dialog>
</template>
<script>
import config from "../../config";
import draggable from 'vuedraggable'
export default {
  name: "groupDlgController",
  mixins: [config.globalMixin],
  data() {
    return {
      page: 0,//当前页数
      pagesize:5,//一页显示几条
      sortType:"ASC",
      sortField:"id",
      searchName: "",
      searchStatus: null,
      total:0,
      rows:[],
      multipleSelection:[],
    };
  },
  components: {
    draggable,
  },
  methods: {
    cancel: function() {
      this.$store.commit("setordereventlist", { string: "", boolean: false });
    },
    async init() {
      let obj = this.getAuthObj();
      obj.apiUrl = '/getAllHighlightsEventList'
      let data = await this.$store.dispatch("apiEvent", obj);
      if(!data) return;
      let list = null;
      for (list of data.data.resultList) {
        if (list.status == 1) {
          list.status = "Active";
        } else {
          list.status = "Inactive";
        }
      }
      this.total = data.data.totalRows;
      this.$set(this, "rows", data.data.resultList);
    },
    addEvent:function(){
      this.$store.state.ordereventListObj.callback(this.rows)
    }
  },
  computed:{
      _obj(){
        return this.$store.state.ordereventListObj.groupFalg
      }
  },
  watch: {
    _obj:function(){
      if(this.$store.state.ordereventListObj.groupFalg){
        this.init();
      }
    }
  },
  mounted() {
    // this.init();
  },
};
</script>
